import { uniqueId } from 'lodash'
import { CreationToolSourceFile } from '../types'
import CreationToolFileType from '../types/file-type'

/**
 * Returns an unvalidated source file object. (used to skip validation for bulk uploading)
 */
const getUnvalidatedSource = (source: File | string): CreationToolSourceFile => ({
    id: uniqueId(),
    source,
    type: CreationToolFileType.UNVALIDATED_FILE,
    height: 0,
    width: 0,
    duration: 0,
    frames: [],
    preview: document.createElement('canvas'),
    hasAudio: false,
    isTransparent: false,
    isAnimated: false,
    isUrl: typeof source === 'string',
})

export default getUnvalidatedSource
